import { Typography, Flex } from "antd";
import { InputBox } from "Components/TextInputBox";
import { TitleCardsList } from "Components/SelectableCard/Title";
import { SingleSelectDropdown } from "Components/SingleSelectDropdown";

const AthleteLevels = [
  {
    title: "State",
  },
  {
    title: "National",
  },
  {
    title: "International",
  },
];

const options = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const Athlete = ({
  isAthlete,
  setIsAthlete,
  sport,
  setSport,
  level,
  setLevel,
}) => {
  const { Title } = Typography;
  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
    >
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>Athlete</Title>
      <SingleSelectDropdown
        options={options}
        placeholder="Are you an athlete"
        loading={false}
        onChange={setIsAthlete}
        value={isAthlete ? "Yes" : "No"}
      />
      {isAthlete && (
        <>
          <Title
            style={{ fontSize: "18px", marginTop: "24px", fontWeight: "500" }}
          >
            Sport
          </Title>
          <InputBox
            placeholder="Sport"
            value={sport}
            onChange={setSport}
            required={false}
            widthSize={"large"}
            heightSize="small"
          />
          <Title
            style={{ fontSize: "18px", marginTop: "24px", fontWeight: "500" }}
          >
            Level
          </Title>
          <Flex wrap>
            <TitleCardsList
              options={AthleteLevels}
              selectedCard={level}
              setSelectedCard={setLevel}
            />
          </Flex>
        </>
      )}
    </Flex>
  );
};
